import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import { BOARDS } from "@Broker/@Modules/clients/board/store/board-getters";
import { LOAD_BOARDS } from "@Broker/@Modules/clients/board/store/board-actions";
import BoardsDropdown from "@Broker/@Modules/util-components/board/boards-dropdown.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "MoveBoardDropdown",
  components: {
    BoardsDropdown
  },
  props: {
    profile: {
      type: Object,
      required: true
    },
    clientProfileId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      hovering: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("BoardStore", [BOARDS])), {}, {
    boardId() {
      var _statusLabels$;
      const {
        statusLabels
      } = this.profile;
      return statusLabels == null ? void 0 : (_statusLabels$ = statusLabels[0]) == null ? void 0 : _statusLabels$.boardId;
    }
  }),
  mounted() {
    if (!this.BOARDS.length) this.LOAD_BOARDS();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [LOAD_BOARDS])), {}, {
    handleShowTooltip() {
      this.$nextTick(() => {
        $(".dropdown-menu", this.$el).dropdown("show");
      });
    },
    handleHideTooltip() {
      this.$nextTick(() => {
        $(".dropdown-menu", this.$el).dropdown("hide");
      });
    },
    handleBoardSelect(event, {
      boardId
    }) {
      this.$emit("select", boardId);
    }
  })
});